import { ListItem, ListItemIcon, ListItemText, Tooltip, Typography, useTheme } from '@mui/material'
import React, { ReactNode } from 'react'
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore'

interface RenderBoardLinkProps {
  title: string
  _route?: string
  onNavigate: (route: string) => void
  boardTheme: string
  icon: ReactNode
  disabled: boolean
  route?: string
}

const RenderBoardLink: React.FC<RenderBoardLinkProps> = ({ title, _route, onNavigate, boardTheme, icon, disabled, route }) => {
  const theme = useTheme()
  const [isHovered, setIsHovered] = React.useState(false)

  return (
    <ListItem
      key={title}
      button
      onClick={() => onNavigate(route)}
      sx={{
        display: 'flex',
        alignItems: 'center',
        padding: '8px 12px',
        borderRadius: '6px',
        filter: 'grayscale(100%)', // Default gray effect
        transition: 'background-color 0.3s border-color 0.3s ease',
        border: `1px solid transparent`,
        '&:hover': {
          filter: 'none', // Remove grayscale on hover
          transition: 'filter 0.2s ease-in-out',
          backgroundColor: 'transparent',
          border: `1px solid ${boardTheme}`,
          '& .MuiSvgIcon-root': {
            color: boardTheme,
          },
          '& .seo-icon': {
            filter: 'none', // Remove grayscale on hover
          },
        },
      }}
      disabled={disabled}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <ListItemIcon
        sx={{
          minWidth: 40,
          color: isHovered ? boardTheme : 'inherit',
          transition: 'color 0.2s ease-in-out',
        }}
      >
        {icon}
      </ListItemIcon>
      <ListItemText primary={title} sx={{ textAlign: 'left', color: theme.palette.text.primary }} />
      {isHovered && (
        <Tooltip title={<Typography>Drag & Drop</Typography>}>
          <UnfoldMoreIcon
            sx={{
              height: 16,
              color: theme.palette.text.primary,
            }}
          />
        </Tooltip>
      )}
    </ListItem>
  )
}

export default RenderBoardLink
